/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax, {
  options: {
    customProperties: true
  }
});

// AXIOS
import "./services/api";

// Optimizely
import "./services/optimizely";

// PostHog
import "./services/posthog";

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "./assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// i18n
import i18n from "./i18n/i18n";

// Vuesax Admin Filters
import "./filters/filters";

// VueAnalytics
import VueAnalytics from "vue-analytics";
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS
});

import Hotjar from "vue-hotjar";
Vue.use(Hotjar, {
  id: "1841111" // Hotjar Site ID
});

// VeeValidate
import VeeValidate, { Validator } from "vee-validate";
import pt_BR from "vee-validate/dist/locale/pt_BR";
Vue.use(VeeValidate, {
  classes: true
});
Validator.localize("pt_BR", pt_BR);

import "vue-search-select/dist/VueSearchSelect.css";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// VueTheMask
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

// VueTheMask Money
import money from "v-money";
Vue.use(money, { precision: 1 });

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

import ViaCep from "vue-viacep";
Vue.use(ViaCep);

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

import LoadScript from "vue-plugin-load-script";

import webPush from "@/services/webPush";
import { initPwaInstall } from "@/services/pwaInstall";
Vue.use(LoadScript);
Vue.loadScript(
  "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"
);

// Antes do app subir: o `beforeinstallprompt` dispara cedo e uma vez so, e um
// ouvinte montado depois nunca o veria.
initPwaInstall();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

// Web Push: registra o Service Worker para receber notificações em segundo plano.
if ("serviceWorker" in navigator && "PushManager" in window) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});

    // Reenvia o "desligar" que não chegou à API na vez anterior. Sem isto a
    // baixa deliberada só apareceria depois como falha de envio, e o servidor
    // a contaria como aparelho morto em vez de escolha da pessoa.
    //
    // O token é comparado com a string "null" de propósito: ao sair, o app grava
    // `setItem("userToken", null)`, e o localStorage guarda isso como texto. Sem
    // esta checagem, quem deslogou dispararia a fila sem sessão e tomaria 401.
    const userToken = localStorage.getItem("userToken");
    if (userToken && userToken !== "null") {
      webPush.flushPendingRemovals().catch(() => {});
    }
  });
}
